import { useDismissOverlayProviderContext } from '@/features/ui/components/Dropdown/contexts/DismissOverlay'
import { useEffect, useId } from 'react'

export const useSetDismissOverlayCloseHandler = (visible: boolean, onClose: () => void): void => {
    const id = useId()

    const { setCloseHandler, clearCloseHandler } = useDismissOverlayProviderContext()

    useEffect(() => {
        if (visible) return setCloseHandler(id, onClose)

        clearCloseHandler(id)
    }, [visible, id, setCloseHandler, onClose, clearCloseHandler])

    useEffect(() => {
        return () => clearCloseHandler(id)
    }, [id, clearCloseHandler])
}
